import React from 'react';
import styles from './TextBox.module.css';
import classnames from 'classnames';
import parseString from "../parseString"


const createMarkup = text => {
  return {__html: text.replace(/\n/g, '<br>')}
};


const TextBox = ({componentBlock, contentData, title, navigation}) => {
  let parsedTitle = title;

  if (title.includes("</span>")) {
    parsedTitle = parseString(title);
  }


  return (
    <div
      className={classnames({
        [styles.wrap]: true,
        [styles.visibleWrap]: componentBlock.visibility,
        [styles.invisibleWrap]: !componentBlock.visibility
      })}
    >
      <div dangerouslySetInnerHTML={createMarkup(parsedTitle)}/>
    </div>
  )
};

export default TextBox;


